'use strict';

var renderCharts = require('../charts/chartsRender');
var competizeAll = require('../review/competitors/competizeAll');

if (!window.isInside) {
  competizeAll(true);
}

renderCharts();
